import React, { useEffect, useState, useCallback } from "react";
import Flex from "../../../components/Flex";
import { useHistory, useParams } from "react-router-dom";
import Content from "../../../components/Content";
import Button from "../../../components/Button";
import ButtonList from "../../../components/ButtonList";
import { useMessageToast } from "../../../components/MessageProvider";
import { useFetch } from "../../../components/useFetch";
import { useAuthState } from "../../../components/AuthProvider";
import { Formik } from "formik";
import * as Yup from "yup";
import Label from "../../../components/Label";
import TextBox from "../../../components/TextBox";
import CheckBox from "../../../components/CheckBox";
import LinkButton from "../../../components/LinkButton";
import Tooltip from "../../../components/Tooltip";
import DropDownList from "../../../components/DropDownList";
import Spinner from "../../../components/Loader/Spinner";

import styles from "./StartRerunTask.module.scss";

const MatchingTask = taskData => {
  // TODO this functionality has been unused and is deprecated
  const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
  const clientConfigApiV1Domain = process.env.REACT_APP_CLIENT_CONFIG_API_V1_DOMAIN;
  const batchLoadsRpcUrl = `${clientConfigApiV1Domain}/rpc/batchloads`;
  const subscriptionsUrl = `${clientConfigApiDomain}/client_subscriptions`;
  const referenceMatching = [
    "Patient Consumer Matching",
    "Contact Person Matching"
  ];

  const { taskId } = useParams();

  const history = useHistory();
  const { user } = useAuthState();
  const toast = useMessageToast();

  const [
    {
      data: batchLoadData,
      hasLoaded: batchLoadDataHasLoaded,
      hasError: batchLoadDataHasError
    },
    batchLoadDataFetch
  ] = useFetch();

  const [taskDataKwargs, setTaskDataKwargs] = useState({});
  const [writeToDynamo, setWriteToDynamo] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [clientSubscriptions, setClientSubscriptions] = useState({});

  const fetchSubscriptions = useCallback(async () => {
    setIsLoading(true);
    const clientSubscriptionResponse = await fetch(
      `${subscriptionsUrl}/?client__oid=${user.preferences.selectedClient.oid}`
    );
    const clientSubscriptionData = await clientSubscriptionResponse.json();
    setClientSubscriptions(clientSubscriptionData.results);
  }, [subscriptionsUrl, user.preferences.selectedClient.oid]);

  useEffect(() => {
    if (taskId !== undefined) {
      const task_kwargs = taskData.taskData.task_kwargs;
      task_kwargs.output_data_location_key_prefix = "";

      if (task_kwargs.persistent_emr_name === "NOT AVAILABLE") {
        task_kwargs.persistent_emr_name = "";
      }

      if (task_kwargs.reference_data_bucket === "NOT AVAILABLE") {
        task_kwargs.reference_data_bucket = "";
      }

      if (task_kwargs.reference_data_file_name === "NOT AVAILABLE") {
        task_kwargs.reference_data_file_name = "";
      }

      if (task_kwargs.reference_data_location_key_prefix === "NOT AVAILABLE") {
        task_kwargs.reference_data_location_key_prefix = "";
      }

      setTaskDataKwargs(task_kwargs);
      setWriteToDynamo(taskData.taskData.task_kwargs.write_to_dynamo);
    } else {
      // this enables the add screen to show up
      setHasLoaded(true);
    }
    fetchSubscriptions().then(() => {
      setIsLoading(false);
      setHasLoaded(true);
    });
  }, [
    taskId,
    hasLoaded,
    user.preferences.selectedClient,
    fetchSubscriptions,
    taskData.task_kwargs,
    taskData.taskData.task_kwargs
  ]);

  useEffect(() => {
    if (taskId === undefined && batchLoadDataHasLoaded) {
      if (batchLoadDataHasLoaded) {
        toast.success(`Batch Load submitted successfully.`);

        history.push(`/tasks`);
      } else if (batchLoadDataHasError) {
        toast.error(`Failed to submit Batch Load.`);
      }
    } else {
      if (batchLoadDataHasLoaded) {
        toast.success(`Batch Load rerun submitted successfully.`);

        history.push(`/tasks`);
      } else if (batchLoadDataHasError) {
        toast.error(`Failed to submit rerun of Batch Load.`);
      }
    }
  }, [
    taskId,
    batchLoadData,
    batchLoadDataHasLoaded,
    batchLoadDataHasError,
    toast,
    history
  ]);

  return (
    <Flex.Item span={12}>
      {isLoading ? (
        <Spinner />
      ) : hasLoaded ? (
        <div className={styles.base}>
          <div className={styles.details}>
            <Formik
              initialValues={{
                clientIdentifier: user.preferences.selectedClient.oid,
                taskId: taskId,
                inputDataBucket: taskDataKwargs.input_data_bucket,
                inputDataLocationKeyPrefix:
                  taskDataKwargs.input_data_location_key_prefix,
                inputDataFileName: taskDataKwargs.input_data_file_names,
                identitySpecDataFileName:
                  taskDataKwargs.identity_spec_data_file_name,
                outputDataBucket: taskDataKwargs.output_data_bucket,
                outputDataLocationKeyPrefix:
                  taskDataKwargs.output_data_location_key_prefix,
                persistentEmrName: taskDataKwargs.persistent_emr_name,
                nearMissThreshold: taskDataKwargs.near_miss_threshold || "-1.0",
                referenceDataBucket: taskDataKwargs.reference_data_bucket,
                referenceDataLocationKeyPrefix:
                  taskDataKwargs.reference_data_location_key_prefix,
                referenceDataFileName: taskDataKwargs.reference_data_file_name
              }}
              validationSchema={Yup.object().shape({
                inputDataBucket: Yup.string().required(
                  "Input Data Bucket field is required."
                ),
                inputDataFileName: Yup.string().required(
                  "Input Data File Name field is required."
                ),
                inputDataLocationKeyPrefix: Yup.string().required(
                  "Input Data Key Prefix field is required."
                )
              })}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                let data = {
                  matching_name: values.matchingName,
                  client_identifier: values.clientIdentifier,
                  input_data_bucket: values.inputDataBucket,
                  input_data_location_key_prefix:
                    values.inputDataLocationKeyPrefix,
                  input_data_file_names: [values.inputDataFileName],
                  identity_spec_data_file_name: values.identitySpecDataFileName,
                  output_data_bucket: values.outputDataBucket,
                  output_data_location_key_prefix:
                    values.outputDataLocationKeyPrefix,
                  persistent_emr_name: values.persistentEmrName,
                  near_miss_threshold: values.nearMissThreshold,
                  write_to_dynamo: writeToDynamo,
                  started_by: user.username
                };
                let method = "";
                let url = "";
                method = "post";
                url = `${batchLoadsRpcUrl}/`;

                if (taskId) {
                  data["rerun_of"] = taskId;
                }

                if (referenceMatching.includes(values.matchingName)) {
                  data["reference_data_bucket"] = values.referenceDataBucket;
                  data["reference_data_location_key_prefix"] =
                    values.referenceDataLocationKeyPrefix;
                  data["reference_data_file_name"] =
                    values.referenceDataFileName;
                }

                batchLoadDataFetch({
                  method,
                  url,
                  data
                });

                setSubmitting(false);
              }}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue
                } = props;

                return (
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <div className={styles.detailsFlex}>
                      <h3>Task Details</h3>
                    </div>
                    <div>
                      <DropDownList
                        id="matchingName"
                        label={
                          <Label htmlFor="matchingName">
                            <b>Matching Name</b>
                          </Label>
                        }
                        onChange={handleChange}
                        required
                        value={values.matchingName}
                        width="33%"
                      >
                        <DropDownList.Item key="Select Matching Name" value="0">
                          Select Matching Name
                        </DropDownList.Item>
                        {clientSubscriptions.map(clientSubscription => (
                          <DropDownList.Item
                            key={clientSubscription.subscription.name}
                            value={`${clientSubscription.subscription.name}`}
                            selected={
                              clientSubscription.subscription.name ===
                              taskData.taskData.task_name
                            }
                          >
                            {clientSubscription.subscription.name}
                          </DropDownList.Item>
                        ))}
                      </DropDownList>
                    </div>
                    <div>
                      <h4>Client OID</h4>
                      <span>{values.clientIdentifier}</span>
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.inputDataBucket
                            ? errors.inputDataBucket
                            : null
                        }
                        id="inputDataBucket"
                        label={
                          <Label
                            error={
                              touched.inputDataBucket && errors.inputDataBucket
                            }
                            htmlFor="inputDataBucket"
                          >
                            <b>Input Data Bucket</b>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.inputDataBucket}
                        width="33%"
                      />
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.inputDataLocationKeyPrefix
                            ? errors.inputDataLocationKeyPrefix
                            : null
                        }
                        id="inputDataLocationKeyPrefix"
                        label={
                          <Label
                            error={
                              touched.inputDataLocationKeyPrefix &&
                              errors.inputDataLocationKeyPrefix
                            }
                            htmlFor="inputDataLocationKeyPrefix"
                          >
                            <b>Input Data Location Key Prefix</b>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.inputDataLocationKeyPrefix}
                        width="33%"
                      />
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.inputDataFileName
                            ? errors.inputDataFileName
                            : null
                        }
                        id="inputDataFileName"
                        label={
                          <Label
                            error={
                              touched.inputDataFileName &&
                              errors.inputDataFileName
                            }
                            htmlFor="inputDataFileName"
                          >
                            <b>Input Data File Name</b>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.inputDataFileName}
                        width="33%"
                      />
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.identitySpecDataFileName
                            ? errors.identitySpecDataFileName
                            : null
                        }
                        id="identitySpecDataFileName"
                        label={
                          <Label
                            error={
                              touched.identitySpecDataFileName &&
                              errors.identitySpecDataFileName
                            }
                            htmlFor="identitySpecDataFileName"
                          >
                            <b>Identity Spec Data File Name</b>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.identitySpecDataFileName}
                        width="33%"
                      />
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.outputDataBucket
                            ? errors.outputDataBucket
                            : null
                        }
                        id="outputDataBucket"
                        label={
                          <Label
                            error={
                              touched.outputDataBucket &&
                              errors.outputDataBucket
                            }
                            htmlFor="outputDataBucket"
                          >
                            <b>Output Data Bucket</b>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.outputDataBucket}
                        width="33%"
                      />
                      <LinkButton
                        onClick={event => {
                          setFieldValue(
                            "outputDataBucket",
                            values.inputDataBucket
                          );
                        }}
                      >
                        Same as Input Bucket
                      </LinkButton>
                    </div>
                    <div className={styles.detailsFlex}>
                      <h3>Advanced Options</h3>
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.outputDataLocationKeyPrefix
                            ? errors.outputDataLocationKeyPrefix
                            : null
                        }
                        id="outputDataLocationKeyPrefix"
                        label={
                          <Label
                            error={
                              touched.outputDataLocationKeyPrefix &&
                              errors.outputDataLocationKeyPrefix
                            }
                            htmlFor="outputDataLocationKeyPrefix"
                          >
                            <b>Output Data Location Key Prefix</b>{" "}
                            <Tooltip>
                              <Content maxWidth="30rem">
                                <p>
                                  Only enter this option if you want a folder to
                                  be generated under the resultant output folder
                                  for this task.
                                </p>
                              </Content>
                            </Tooltip>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.outputDataLocationKeyPrefix}
                        width="33%"
                      />
                    </div>
                    {referenceMatching.includes(values.matchingName) ? (
                      <div className="referenceDetails">
                        <div>
                          <TextBox
                            errorText={
                              touched.referenceDataBucket
                                ? errors.referenceDataBucket
                                : null
                            }
                            id="referenceDataBucket"
                            label={
                              <Label
                                error={
                                  touched.referenceDataBucket &&
                                  errors.referenceDataBucket
                                }
                                htmlFor="referenceDataBucket"
                              >
                                <b>Reference Data Bucket</b>
                              </Label>
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            value={values.referenceDataBucket}
                            width="33%"
                          />
                          <LinkButton
                            onClick={event => {
                              setFieldValue(
                                "referenceDataBucket",
                                values.inputDataBucket
                              );
                            }}
                          >
                            Same as Input Bucket
                          </LinkButton>
                        </div>
                        <div>
                          <TextBox
                            errorText={
                              touched.referenceDataLocationKeyPrefix
                                ? errors.referenceDataLocationKeyPrefix
                                : null
                            }
                            id="referenceDataLocationKeyPrefix"
                            label={
                              <Label
                                error={
                                  touched.referenceDataLocationKeyPrefix &&
                                  errors.referenceDataLocationKeyPrefix
                                }
                                htmlFor="referenceDataLocationKeyPrefix"
                              >
                                <b>Reference Data Location Key Prefix</b>
                              </Label>
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            value={values.referenceDataLocationKeyPrefix}
                            width="33%"
                          />
                        </div>
                        <div>
                          <TextBox
                            errorText={
                              touched.referenceDataFileName
                                ? errors.referenceDataFileName
                                : null
                            }
                            id="referenceDataFileName"
                            label={
                              <Label
                                error={
                                  touched.referenceDataFileName &&
                                  errors.referenceDataFileName
                                }
                                htmlFor="referenceDataFileName"
                              >
                                <b>Reference Data File Name</b>
                              </Label>
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            value={values.referenceDataFileName}
                            width="33%"
                          />
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    <div>
                      <TextBox
                        errorText={
                          touched.persistentEmrName
                            ? errors.persistentEmrName
                            : null
                        }
                        id="persistentEmrName"
                        label={
                          <Label
                            error={
                              touched.persistentEmrName &&
                              errors.persistentEmrName
                            }
                            htmlFor="persistentEmrName"
                          >
                            <b>Persistent EMR Name</b>{" "}
                            <Tooltip>
                              <Content maxWidth="30rem">
                                <p>
                                  Only fill this in when you know that an EMR is
                                  running with the provided name.
                                </p>
                              </Content>
                            </Tooltip>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.persistentEmrName}
                        width="33%"
                      />
                    </div>
                    <div>
                      <TextBox
                        errorText={
                          touched.nearMissThreshold
                            ? errors.nearMissThreshold
                            : null
                        }
                        id="nearMissThreshold"
                        label={
                          <Label
                            error={
                              touched.nearMissThreshold &&
                              errors.nearMissThreshold
                            }
                            htmlFor="nearMissThreshold"
                          >
                            <b>Near Miss Threshold</b>{" "}
                            <Tooltip>
                              <Content maxWidth="30rem">
                                <p>
                                  The match example report will include
                                  identities that score at or above the near
                                  miss threshold as related identities. It also
                                  includes identities that are related for other
                                  reasons, including being related through
                                  manual stewardship and prior partitioning.
                                </p>
                                <p>
                                  Provide value of <b>-1.0</b> if you don't want
                                  the match example report generated.
                                </p>
                              </Content>
                            </Tooltip>
                          </Label>
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        value={values.nearMissThreshold}
                        width="33%"
                      />
                    </div>
                    <div>
                      <p>
                        <b>Write To Dynamo</b>
                      </p>
                      <CheckBox
                        label={writeToDynamo ? "Enabled" : "Disabled"}
                        onChange={() => setWriteToDynamo(write => !write)}
                        selected={writeToDynamo}
                      />
                    </div>
                    <ButtonList>
                      <Button primary type="submit">
                        {taskId ? "Rerun" : "Start"}
                      </Button>
                      <Button
                        onClick={() => {
                          history.push(`/tasks`);
                        }}
                      >
                        Cancel
                      </Button>
                    </ButtonList>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      ) : null}
    </Flex.Item>
  );
};

export default MatchingTask;
